<template>
   <div class="selectAppBox">
     <div class="title">选择应用</div>
     <div class="box">
       <div class="box-item" v-for="item in suite_id_list">
         <img :src="item.avatar" alt="">
         <div class="name">{{item.name}}</div>
         <el-button class="enter" type="primary" @click="selectApp(item)">点击进入</el-button>
       </div>
     </div>
   </div>
</template>

<script>
import { postAuthLogin } from "../api/login";
import Cookies from "js-cookie";

export default {
  name: 'index',
   components: {

  },
  data () {
    return {
      suite_id_list:[
        {name:'群互动',suite_id:'wwe1672b8556d5bfeb',avatar:'https://api-group.chouchoujiang.com/static/admin/images/logo.png'},
        {name:'互动小工具',suite_id:'wwd579740c7542b9c5',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995e100d946.png'},
        {name:'互动大转盘',suite_id:'wwae097389e8998ec1',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995e50b605a.png'},
        {name:'互动活动',suite_id:'wwd90c4c627ba10fad',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995ed02934a.png'},
      ],
      suite_id:'',
      suite_name:'',
    }
  },
  methods:{
    selectApp(item){
       Cookies.set('suite_id',item.suite_id,{ expires: 7 });
       Cookies.set('suite_name',item.name,{ expires: 7 });
       location.href="/#/userinfo"
       setTimeout(()=>{
         window.location.reload()
       },500)
    }

  },
  created(){


  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  type="text/scss" lang="scss" >

	.selectAppBox{
	  width: 900px;
	  margin: 250px auto;

	  border-radius: 10px;
	  .title{
	    font-size: 30px;
	    font-weight: bold;
	    height: 80px;
	    line-height: 80px;

	    text-align: center;
	  }
	  .box{
	    background: #ffffff;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    flex-wrap: wrap;
	    border: 1px solid #ececec;
	    .box-item{
	      width: 50%;

	      padding: 20px 0;
	      border: 1px solid #ececec;
	      box-sizing: border-box;
	      .name{
	        font-size: 16px;
	        text-align: center;
	      }
	      img{
	        width: 75px;
	        height: 75px;
	        border-radius: 5px;
	        display: block;
	        margin: 20px auto;
	      }
	      .enter{
	        display: block;
	        margin: 20px auto;

	      }
	    }
	  }
	}
</style>



// WEBPACK FOOTER //
// src/components/select.vue